<template>
  <div class="console_r">
    <!-- <sub-header :id="queryParams.hennery_id" name="building"></sub-header> -->
    <div class="console_r_card">
      <div class="title">
        <b>{{currHenneryName}} - 分栋列表<i @click="refresh" class="el-icon-refresh" title="刷新"></i></b>
        <!-- <span>当前记录：{{count}}</span> -->
      </div>
      <div class="con">
        <div class="con_top" style="padding: 30px 0;">
          <!-- <el-select v-model="queryParams.status" style="width: 200px">
            <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
          <el-button type="primary" @click="refresh" round>查询</el-button> -->
        </div>
        <el-table :data="list" style="width: 100%" border>
          <!-- <el-table-column prop="id" label="ID"></el-table-column> -->
          <el-table-column prop="name" label="分栋名称"></el-table-column>
          <el-table-column prop="device_num" label="设备数"></el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="viewDetail(scope.row)" round>进入栋</el-button>
                <el-button type="danger" size="mini" @click="openModifyDialog(scope.row)" round>修改名称</el-button>
              </template>
            </el-table-column>
        </el-table>
      </div>
      <!-- <div style="text-align: center">
        <el-pagination
        style="padding: 20px 0 40px"
        background
        layout="prev, pager, next"
        @current-change="currPageChange"
        :page-size="queryParams.limit"
        :total="count">
        </el-pagination>
      </div> -->
    </div>
    <!--弹框-->
    <el-dialog 
    class="dialog"
    :title="`${dialogData.name}俯视图`" 
    width="1000px"
    :visible.sync="dialogVisible">
      <div class="detail-item">
        <div class="farm-view">
          <el-image style="width: 100%" :src="dialogData.image"></el-image>
          <!-- <div class="microphone-icon" :style="{background: url(IconGreen)}"></div> -->
          <div 
          class="microphone-icon"
          :style="{left:`${scaleRatio*item.x-16}px`, top: `${scaleRatio*item.y-16}px`}" 
          v-for="item in dialogData.devices"
          :key="item.device_id"
          @click="goDevice(item.device_id, item.name)"
          >
            <el-image 
            :src="item.status === 1 ? iconGreenUrl : iconRedUrl"></el-image>
            <!-- <div class="microphone-id">{{item.device_id}}</div> -->
            <div class="microphone-name">
              <!-- <span>ID：{{item.device_id}}</span><br /> -->
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog 
    class="dialog"
    title="修改" 
    width="600px"
    :visible.sync="modifyDialogVisible">
      <div class="detail-item">
        <el-form ref="editPostParams" label-width="140px">
          <el-form-item label="鸡场名称：">
            <el-input type="input" v-model="modifyName" placeholder="请输入设备昵称"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: right;">
          <el-button 
          type="primary"
          @click="modifyNameFun()" 
          :disabled="!modifyName || modifyName === currName"
          >修 改</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog 
    class="dialog"
    :title="`设备${currDeviceId}（${currDeviceName}）`" 
    width="1000px"
    :visible.sync="deviceDialogVisible">
      <div class="detail-item">
        <device-audio v-if="deviceDialogVisible" :id="currDeviceId"></device-audio>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import { getBuildingListApi, getBuildingCountApi, modifyBuildingApi } from '@/api/user'
// import ShAudio from '@/components/Audio'
import IconGreen from '@/assets/images/microphone_green.png'
import IconRed from '@/assets/images/microphone_red.png'
import SubHeader from '@/components/SubHeader'
import DeviceAudio from '@/components/DeviceAudio'

export default {
  name: 'FarmView',
  components: {
    // ShAudio
    DeviceAudio,
    // SubHeader
  },
  data() {
    return {
      currHenneryName: '',
      queryParams: {
        skip: 0,
        limit: 100,
        hennery_id: Number(this.$route.params.id)
      },
      list: [],
      count: 0,
      dialogVisible: false,
      dialogData: {
        name: ''
      },
      iconGreenUrl: IconGreen,
      iconRedUrl: IconRed,
      scaleRatio: 0,
      currId: null,
      modifyDialogVisible: false,
      modifyName: '',
      currName: '',
      deviceDialogVisible: false,
      currDeviceId: null,
      currDeviceName: ''
    }
  },
  methods: {
    getList () {
      getBuildingListApi(this.queryParams).then(res=>{
        let data = res.data.data.buildings
        if(!data || data.length <= 0) {
          return
        }
        this.list = data.sort((a, b) => a.name.localeCompare(b.name))
        this.currHenneryName = res.data.data.hennery.name
        this.list.forEach((item) => {
          item.device_num = 0
          if(item.devices && item.devices.length > 0) {
            item.device_num = item.devices.length
            item.devices.forEach(i => {
              i.name = !!i.device_custom_name ? i.device_custom_name : i.device_hostname
              const pos = i.device_image_pos.split(',')
              i.x = Number(pos[0])
              i.y = Number(pos[1])
            })
          }
        })
        console.log('this.list', this.list)
        this.loadingData = false
      }).catch(() => {
        this.loadingData = false
      })
    },
    getCount () {
      getBuildingCountApi(this.queryParams).then(res => {
        this.count = res.data.data.count
      })
    },
    modifyNameFun () {
      modifyBuildingApi(this.currId, {name: this.modifyName}).then(res=>{
        Message.success('修改成功')
        this.getList()
        this.modifyDialogVisible = false
      }).catch(() => {
        Message.error('修改失败')
      })
    },
    openModifyDialog (item) {
      this.modifyDialogVisible = true
      this.currId = item.id
      this.currName = item.name
      this.modifyName = item.name
    },
    refresh () {
      this.getList()
      // this.getCount()
    },
    currPageChange (currPage) {
      this.queryParams.skip = (currPage - 1) * this.queryParams.limit
      this.getList()
    },
    viewDetail (item) {
      const _this = this
      _this.dialogVisible = true
      _this.dialogData = item
      const img = new Image()
      img.src = item.image
      img.onload = () => {
        console.log(img.width, img.height)
        _this.scaleRatio = 940/img.width
      }
      
    },
    goDevice (id, name) {
      this.currDeviceId = id
      this.currDeviceName = name
      this.deviceDialogVisible = true
      // this.$router.push({
      //   name: 'home',
      //   params: {
      //     id,
      //     name
      //   }
      // })
    }
  },
  watch: {

  },
  created(){
    this.$store.commit('setCurrHenneryId', this.$route.params.id)
    this.refresh()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import 'poultry.scss';
.farm-view {
  position: relative;
  .microphone-icon {
    position: absolute;
    left: 0;
    top: 0;
    width: 40px;
    height: 40px;
    padding: 5px;
    border-radius: 50%;
    background-color: #ffffff;
    cursor: pointer;
    .microphone-id {
      position: absolute;
      left: -4px;
      top: -1px;
      font-size: 10px;
      color: #000;
      width: 20px;
      height: 10px;
      line-height: 10px;
      // transform: scale(0.6);
      // -webkit-transform: scale(0.6);
      // -moz-transform: scale(0.6);
      // -o-transform: scale(0.6);
      // -ms-transform: scale(0.6);
    }
    .microphone-name {
      position: absolute;
      top: 42px;
      left: -30px;
      font-size: 10px;
      color: #000;
      width: 100px;
      line-height: 14px;
      text-align: center;
      span {
        display: inline-block;
        padding: 1px 4px;
        background-color: #fff;
      }
    }
  }
}
</style>
